function shouldOpenInLightbox({
  componentRef,
  displayData,
  forceOpenInLightbox
}) {
  // If in-page embed isn't true - then it should always open in cinema mode.
  //
  // NB: For some reason the legacy iframe used model.autoActive instead of
  // model.inPageEmbed to check whether or not in-page-embed was active. Hence
  // we must replicate this logic as to not break old integrations..
  if (forceOpenInLightbox) {
    return true;
  }
  const component = componentRef.current;
  const minWidth = displayData?.minSize?.width;

  // In case the iframe is not wide enough to fit inside the embed, then it
  // should be opened in a lightbox instead.
  if (component && minWidth && component.offsetWidth < minWidth) {
    return true;
  }
  return false;
}

export { shouldOpenInLightbox };
//# sourceMappingURL=util.should-open-in-lightbox.js.map
